import type { GameConfig } from '../types.js';

const FULL = 100;

function clamp(value: number): number {
    return Math.min(Math.max(value, 0), FULL);
}

export function happiness(config: GameConfig): number {
    const initial = config.happiness?.initial ?? FULL;
    const effects = config.happiness?.effects ?? {};

    const active = [...(config.challenges ?? []), ...(config.economics ?? [])];
    const total = active.reduce((sum, id) => sum + (effects[id] ?? 0), initial);

    return clamp(total);
}

export function productionRate(config: GameConfig): number {
    return happiness(config) / FULL;
}
